module.exports = __webpack_public_path__ + "imgs/hand-card-small.780d6bb0304b5752e23d4d8c96216d62.png";